export const makeTypeGuard = <T extends string>(values: readonly T[]) => {
  const set = new Set<string>(values)
  return (value: string): value is T => set.has(value)
}
